<template >
    <div style="text-align: center" id="app">
      <br>
      <div id="checkin" class="container">
          <div class="row align-items-center justify-content-center">
          <div class="col-md-7 text-center" data-aos="fade">
              <h1 class="mb-4 sub-heading">{{$t('Reclamos["Titulo"]')}}</h1>
              <span class="caption mb-3 sub-heading">{{$t('Reclamos["Comentario"]')}}</span>
          </div>
          </div>
      </div>
      <div class="site-section site-section-sm">
            <div class="container">
            <div class="row">
                <div class="col-md-8 offset-md-2 ">
                  <form action="#" class="p-5 bg-white">
                    <div class="row form-group">
                    <div class="col-md-12 mb-3 mb-md-0">
                        <label class="font-weight-bold" for="fullname">{{$t('WebCheckin["Labels"]["Nombre"]')}}</label>
                        <input v-model="name" type="text" id="fullname" class="form-control" :placeholder="$t('WebCheckin.Placeholders.Nombre')">
                    </div>
                    </div>
                    <div class="row form-group">
                    <div class="col-md-12">
                        <label class="font-weight-bold" for="email">{{$t('WebCheckin["Labels"]["Correo"]')}}</label>
                        <input v-model="email" type="email" id="email" class="form-control" :placeholder="$t('WebCheckin.Placeholders.Correo')">
                    </div>
                    </div>
                     <div class="row form-group">
                    <div class="col-md-12">
                        <label class="font-weight-bold" for="phone">{{$t('WebCheckin["Labels"]["Telefono"]')}}</label>
                        <input v-model="phone" type="phone" id="phone" class="form-control" :placeholder="$t('WebCheckin.Placeholders.Telefono')">
                    </div>
                    </div>
                     <div class="row form-group">
                    <div class="col-md-12">
                        <label class="font-weight-bold" for="direction">{{$t('WebCheckin["Labels"]["Direccion"]')}}</label>
                        <input v-model="address" type="address" id="address" class="form-control" :placeholder="$t('WebCheckin.Placeholders.Direccion')">
                    </div>
                    </div>
                    <div class="row form-group">
                    <div class="col-md-12">
                        <label class="font-weight-bold" for="fullname">{{$t('WebCheckin["Labels"]["HotelReclamo"]')}}</label>
                        <el-select class="form-control" id="hotel" :placeholder="$t('WebCheckin.Placeholders.Hotel')" v-model="hotelSelected">
                            <el-option 
                                v-for="(hotel, key) in hotelData" 
                                :key="key" 
                                :value="hotel.name" 
                                :label="hotel.name">
                                {{hotel.name}}
                            </el-option>
                        </el-select> 
                    </div>
                    </div>                  
                    <div class="row form-group">
                        <div class="col-md-12">
                            <label class="font-weight-bold" for="tipoDocumento">{{$t('WebCheckin["Labels"]["Documento"]')}}</label>
                            <el-select id="tipoDocumento" class="form-control" v-model="tipoDocumento">
                                <el-option :selected="true" disabled value="">{{$t('WebCheckin["Labels"]["DocumentoOpc"]')}}</el-option>
                                <el-option
                                v-for="item in tipoDocs"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-md-12 mb-3 mb-md-0">
                            <label class="font-weight-bold" for="phone">{{$t('WebCheckin["Labels"]["NroDocumento"]')}}</label>
                            <input v-model="nroDocumento" type="text" id="nroDocumento" class="form-control" :placeholder="$t('WebCheckin.Placeholders.NroDocumento')">
                        </div>
                    </div>                                        
                    <div class="row form-group">
                        <div class="col-md-12 mb-3 mb-md-0">
                            <label class="font-weight-bold" for="message">{{$t('Reserva["Labels"]["Mensaje"]')}}</label>
                            <textarea v-model="problem" name="message" id="message" cols="30" rows="5" class="form-control" :placeholder="$t('Reserva.Placeholders.Mensaje')"></textarea>
                        </div>                      
                    </div>
                    <br>  
                    <div class="row form-group">
                        <div class="col-md-12">
                            <a @click="SendMail()" style="color:white" class="btn btn-primary pill px-4 py-2">{{$t('WebCheckin["Labels"]["EnviarReclamo"]')}}</a>
                        </div>
                    </div>                    
                  </form>
                </div>
            </div>
            </div>
          </div>
        <br>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios';
import { db } from '@/firebase.js'
import MyComponent from './../MailTemplates/Reclamos.vue'

export default {
    components: {
        MyComponent
    },
    name: 'LibroReclamos',
    data() {
        return {       
            hotelSelected: null,
            hotelData: null,
            datosHotel: null,
            tipoDocumento: null,
            name: null,
            email: null,
            phone: null,
            address: null,
            problem: null,
            nroDocumento: null,
            firma: null,
            empresaMail: null,
            tipoDocs: [{
            value: 'Pasaporte',
            label: this.$i18n.locale=='es' ? 'Pasaporte' :'Passport'
            }, {
            value: 'RUC',
            label: 'RUC'
            }, {
            value: 'DNI',
            label: this.$i18n.locale=='es' ?'DNI':'ID'
            }, {
            value: 'Carnet de extranjería',
            label: this.$i18n.locale=='es' ? 'Carnet de extranjería' : 'foreigns card'
            }, {
            value: 'Otros',
            label: this.$i18n.locale=='es' ?'Otros':'Other'
            }],        
        }
    },
   methods: {   
    
    async SendMail () { 

            if(this.$i18n.locale=='es'){
                this.$message({
                    message: 'Su mensaje esta siendo enviado, porfavor espere, gracias.',
                    type: 'info'
                });
                
                if(this.hotelSelected === null)
                {
                    this.message = "Es necesario que señale en que hotel realizó la reserva"
                    this.failure()
                    return
                }
                if(this.tipoDocumento === null)
                {
                    this.message = "Estimado, debe elegir el tipo de documento con el que realizó la reserva"
                    this.failure()
                    return
                }
                if(this.name === null)
                {
                    this.message = "Es necesario que introduzca su nombre completo"
                    this.failure()
                    return
                }
                if(this.phone === null)
                {
                    this.message = "Es necesario que nos dé su número de teléfono"
                    this.failure()
                    return
                }
                if(this.address === null)
                {
                    this.message = "Es necesario que coloque su dirección"
                    this.failure()
                    return
                }
                if(this.problem === null)
                {
                    this.message = "Es imperativo que nos diga el motivo de su reclamo"
                    this.failure()
                    return
                }
                if( this.nroDocumento === null)
                {
                    this.message = "Porfavor necesitamos que ingrese su número de documento de identidad"
                    this.failure()
                    return
                }
                if( this.email === null || !this.validateEmail(this.email))
                {
                    this.message = "Tiene que dejar un correo válido para poder comunicarnos con usted"
                    this.failure()
                    return
                }         
            }else{
                this.$message({
                    message: 'your message is being send, please wait.',
                    type: 'info'
                });
                
                if(this.hotelSelected === null)
                {
                    this.message = "It is necessary to indicate in which hotel you made the reservation"
                    this.failure()
                    return
                }
                if(this.tipoDocumento === null)
                {
                    this.message = "Dear, you must choose the type of document with which you made the reservation"
                    this.failure()
                    return
                }
                if(this.name === null)
                {
                    this.message = "You need to enter your full name"
                    this.failure()
                    return
                }
                if(this.phone === null)
                {
                    this.message = "You need to give us your phone number"
                    this.failure()
                    return
                }
                if(this.address === null)
                {
                    this.message = "You need to put your address"
                    this.failure()
                    return
                }
                if(this.problem === null)
                {
                    this.message = "It is imperative that you tell us the reason for your claim"
                    this.failure()
                    return
                }
                if( this.nroDocumento === null)
                {
                    this.message = "Please we need you to enter your identity document number"
                    this.failure()
                    return
                }
                if( this.email === null || !this.validateEmail(this.email))
                {
                    this.message = "You have to leave a valid email to be able to contact you"
                    this.failure()
                    return
                }         
            }

            const vm = new Vue({
                render: h => h(MyComponent, {
                    props: {
                        name: this.name,
                        problem: this.problem,
                        mail: this.email,
                        hotel: this.hotelSelected,
                        phone: this.phone,
                        document: this.tipoDocumento,
                        documentNumber: this.nroDocumento,
                        address: this.address
                    }
                })
            })

            const html = vm.$mount().$el.outerHTML

            let url = 'https://ctws.azurewebsites.net/MailApi/SendEmail/?x=Nno2ufull9A2O8hO8jEEijE2PgrsB79Wzybiaysq0sOW+9TEtsf1gVigYt59z363ArlqzybbPLRNci9NHHYFBbU2SHL6oxmf5tDYcuWxVwGo1rqAclluxoYpCpzWI4EeDLCtoqJPsLMZe0K81uK+H2bBTygUlWAmkw04xVF+yVbp93b4h6vC3I/7GXPqjUD+yX2mWfPwms72J85WU2Q5IfoAeNp5V26KAukPUS5iFnM8D2qCzL+nBLVGDoU81PRUNCspnKeyf4RkdkBxxKBpEfDTcTwDmw9cnC8UTVv4n22er/rWbPQDdsoqpEukRlm8L+Iu5Ug0Rl+/QmJvyG1GqOYcdXVqsBKmW3tKm3AaYvZo1jfAZBQGy7BjDG3uyAku';

            const jsonSend = {
                "emailTo":[               
                    this.empresaMail, this.email
                ],
                "emailFrom" :  'notificaciones@chevere.tech',
                "subject" : "Nuevo mensaje de su página web",
                "body" :  btoa(html),
                "attachments" : null
            }            

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: { 
                    'Content-Type': 'application/json'
                },
                data : jsonSend
            };

            axios.request(config)
            .then((response) => {
                this.success(); 
            })
            .catch((error) => {
                this.failure();    
            });

      
        //     this.success();    
        },
        failure() {            
            this.$message.error(this.message);
        },
        validateEmail(email) {
            const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
            return re.test(email);
        },
        success() {
            this.$message({
            message: 'Su mensaje ha sido enviado, nos pondremos en contacto con usted lo más pronto posible, gracias.',
            type: 'success'
            });
            this.name= null;
            this.phone= null;
            this.email= null;
            this.problem= null;
            this.address= null;
            this.hotelSelected= null;
            this.tipoDocumento= null;
            this.nroDocumento= null;
        },
        async getHotelData() {
           try {
                this.hotelData = (
                    await db
                    .child("tambohotels")
                    .once("value")                    
                ).val()
                
            } catch (ex) {
                return console.error(ex)
            }          
        }, 
        async getMail() {
           try {
                let data = (
                    await db
                    .child("reclamos")
                    .once("value")
                ).val()
                this.empresaMail = data.MailParaReclamos.mail;

            } catch (ex) {
                return console.error(ex)
            }          
        },    
        async loadHotel ( hotel ) {            
            try {
                let data = (
                    await db
                    .child("tambohotels")
                    .once("value")                    
                ).val()

                for (let elem in data) {
                    if(elem == hotel)
                    {    
                      this.datosHotel = data[elem]; 
                    }
                }   
            } catch (ex) {
                return console.error(ex)
            }          
        },                 
        onChange ( event ) {
            this.loadHotel(this.hotelSelected) 
        },      
    },
    async created () {
        await this.getHotelData()
        await this.getMail()
        //console.log(this.empresaMail)
    },
};
</script>

<style scoped>
    #checkin{
        padding-top: 100px;
    }
    .sub-heading{
      color: black !important;
    }
    
</style>


// WEBPACK FOOTER //
// LibroReclamos.vue?4021d68f